import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // 添加滚动行为配置
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '广州亚标-中国产业补贴合作平台 企业补贴专家'
          }
        }, {
          path: '/about',
          name: 'about',
          component: resolve => require(['@/view/about'], resolve),
          meta: {
            title: '关于我们'
          },
          
        }, {
          path: '/keygroups',
          name: 'keygroups',
          component: resolve => require(['@/view/keygroups'], resolve),
          meta: {
            title: '超长期特别国债'
          }
        }, {
          path: '/hongKongBUD',
          name: 'hongKongBUD',
          component: resolve => require(['@/view/HongKongBUD'], resolve),
          meta: {
            title: '香港BUD'
          }
        }, {
          path: '/highEnterpriseRecognition',
          name: 'highEnterpriseRecognition',
          component: resolve => require(['@/view/HighEnterpriseRecognition'], resolve),
          meta: {
            title: '中央预算内投资'
          }
        }, {
          path: '/businessScope',
          name: 'businessScope',
          component: resolve => require(['@/view/BusinessScope'], resolve),
          meta: {
            title: '业务范围'
          }
        },
        , {
          path: '/successCases',
          name: 'successCases',
          component: resolve => require(['@/view/successCases'], resolve),
          meta: {
            title: '成功案例'
          }
        },
        {
          path: '/contactUs',
          name: 'contactUs',
          component: resolve => require(['@/view/ContactUs'],resolve),
          meta: {
            title: '加入我们'
          }
        }
      ]
    }
  ]
 
})



// WEBPACK FOOTER //
// ./src/router/index.js